import { clone, remove } from 'lodash'
import { AiOutlineClose, AiOutlinePlus } from 'react-icons/ai'

import { Button, Select, TextInput } from 'Components/Form'

export const dataDefault = {
    material_id: '',
    weight: '',
}

export default function BatchMaterial({ index, datas, data, handleChange, touched, errors, materials }) {
    var name = `batch_material[${index}].`

    const setDate = (name, value) => {
        var saveMaterial = clone(datas)
        saveMaterial = saveMaterial.map((e, i) => {
            if (i === index) {
                e[name] = value
            }
            return e
        })
        handleChange('batch_material', saveMaterial)
    }

    return (
        <div className="flex flex-col gap-3">
            <div className="grid grid-cols-3 gap-3 sm:grid-cols-5">
                <Select
                    id={`${name}material_id`}
                    name={`${name}material_id`}
                    label={index === 0 ? 'Material' : null}
                    placeholder="Select"
                    value={data.material_id}
                    options={materials.map(e => ({
                        id: e.id,
                        label: e.title,
                    }))}
                    onChange={e => setDate(`material_id`, e.target.value)}
                    error={touched?.material_id && errors?.material_id}
                    className="col-span-3 sm:col-span-2"
                />
                <TextInput
                    type="number"
                    id={`${name}weight`}
                    name={`${name}weight`}
                    label={index === 0 ? 'Weight' : null}
                    placeholder="Weight"
                    value={data.weight}
                    onChange={e => setDate(`weight`, e.target.value)}
                    error={touched?.weight && errors?.weight}
                    min="1"
                    className="col-span-2 sm:col-span-2"
                />
                <div>
                    <div className={`flex items-center gap-3 ${index === 0 ? 'pt-7' : null}`}>
                        {index + 1 === datas.length ? (
                            <Button
                                type="button"
                                className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                onClick={() => {
                                    var saveTask = clone(datas)
                                    saveTask.push(clone(dataDefault))
                                    handleChange('batch_material', saveTask)
                                }}
                            >
                                <AiOutlinePlus size={20} />
                            </Button>
                        ) : (
                            <Button
                                type="button"
                                className="text-white border-danger bg-danger"
                                onClick={() => {
                                    var saveTask = clone(datas)
                                    remove(saveTask, (n, key) => key === index)
                                    handleChange('batch_material', saveTask)
                                }}
                            >
                                <AiOutlineClose size={20} />
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
